/**
 * Color utility functions
 */

/**
 * Convert hex color to rgba with alpha transparency
 * @param {string} hex - Hex color code (e.g., '#1d2b50')
 * @param {number} alpha - Alpha value 0-1 (default: 1)
 * @returns {string} rgba color string
 */
export function hexToRgba(hex, alpha = 1)
{
    const sanitized = hex.replace('#', '');
    const bigint = parseInt(sanitized, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
